// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".theme--dark>.gfilm-responsive-dialog__content[data-v-468194e8]{background:var(--v-modalBackgroundDark-base)}.theme--light>.gfilm-responsive-dialog__content[data-v-468194e8]{background:var(--v-modalBackground-base)}.v-dialog--fullscreen .gfilm-responsive-dialog__content[data-v-468194e8]{border-radius:1rem 1rem 0 0;overflow:auto;pointer-events:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
